import Sortable from "sortablejs"

// Drag-to-reorder on the creator variants page. Order persists immediately
// through the sort endpoint; each card's form is otherwise a plain submit.
$(document).on("turbolinks:load", function () {
  var list = document.getElementById("js-variant-cards")
  if (!list) return

  new Sortable(list, {
    handle: ".draggable-handle",
    animation: 150,
    onEnd: function () {
      var ids = $(list)
        .children("[data-variant-id]")
        .map(function () {
          return $(this).data("variant-id")
        })
        .get()
        .filter(Boolean)

      $.ajax({
        url: list.dataset.sortUrl,
        method: "POST",
        data: { order: ids },
        headers: {
          "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content"),
        },
      })
    },
  })
})
